module.exports = __webpack_public_path__ + "img/cluster_logistics_100px_bluebox.019150de.png";